import { forwardRef } from "react";

import Input from "./Input";
import TipTapCE from "./TipTapCE";

const FnrInput = forwardRef((props, ref) => {
  if (props.type === "contenteditable") {
    return <TipTapCE {...props} />;
  }
  return <Input {...props} ref={ref} />;
});
FnrInput.displayName = "FnrInput";
export default FnrInput;

export { InputWrapper } from "./Wrapper";
